import { render, staticRenderFns } from "./SocialLearningOverflowMenuSearchPost.vue?vue&type=template&id=f43aa4c4&scoped=true&"
import script from "./SocialLearningOverflowMenuSearchPost.vue?vue&type=script&lang=js&"
export * from "./SocialLearningOverflowMenuSearchPost.vue?vue&type=script&lang=js&"
import style0 from "./SocialLearningOverflowMenuSearchPost.vue?vue&type=style&index=0&id=f43aa4c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f43aa4c4",
  null
  
)

export default component.exports